module.exports = __webpack_public_path__ + "img/recording.354f3086.gif";